import React from "react";

const PageNotFound = () => {
  return (
    <div>
      <h1 className="x-large text-primary">
        <i className="fa fa-exclamation-triangle"></i> Page Not Found!
      </h1>
      <p className="large">This page doesn't exists!</p>
    </div>
  );
};

export default PageNotFound;
